import { render } from "./ScaricamentoContenuti.vue?vue&type=template&id=9a050632&scoped=true"
import script from "./ScaricamentoContenuti.vue?vue&type=script&lang=js"
export * from "./ScaricamentoContenuti.vue?vue&type=script&lang=js"

import "./ScaricamentoContenuti.vue?vue&type=style&index=0&id=9a050632&scoped=true&lang=css"

import exportComponent from "G:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a050632"]])

export default __exports__